/* ==========================================================================
   Collection · Sacs — comportements
   - onglets par modèle : la grille n’affiche que ce modèle (sans recharger la page)
   - clic sur un modèle ou une entrée du titre : même effet, puis défilement jusqu’à la grille
   - affichage 4 ou 2 par rangée (desktop), mémorisé pour la visite
   - tri : liste (desktop) ou menu natif (mobile)
   - filtres : tiroir à droite (desktop) / feuille qui monte du bas (mobile) ;
     « Voir les N sacs » se met à jour à chaque choix (Section Rendering API)
   ========================================================================== */
(function () {
  'use strict';
  var O = window.OBAIA;

  function init(scope) {
    var root = O.$('[data-section="collection"]', scope);
    if (!root || root.__ok) return;
    root.__ok = true;

    var grille = O.$('[data-grille]', root);
    var compteurs = O.$$('[data-compte]', root);
    var mot1 = root.getAttribute('data-mot-1'), motN = root.getAttribute('data-mot-n');
    function libelle(n) { return n + ' ' + (n === 1 ? mot1 : motN); }

    /* Onglets ---------------------------------------------------------------- */
    var onglets = O.$$('[data-onglet]', root);
    // Un onglet filtre par modèle (« alba »), par catégorie (« sac », « accessoire ») ou par prix maximum (en centimes)
    function filtrer(b) {
      if (!grille) return;
      var modele = b ? b.getAttribute('data-onglet') : '';
      var cat = b ? b.getAttribute('data-onglet-categorie') : '';
      var pmax = b ? parseInt(b.getAttribute('data-onglet-prix'), 10) : NaN;
      var tous = !modele && !cat && isNaN(pmax);
      var n = 0;
      O.$$('[data-tuile]', grille).forEach(function (t) {
        var ok = (!modele || t.getAttribute('data-modele') === modele) &&
                 (!cat || t.getAttribute('data-categorie') === cat) &&
                 (isNaN(pmax) || parseInt(t.getAttribute('data-prix'), 10) <= pmax);
        t.hidden = !ok;
        if (ok) { n++; t.style.opacity = ''; if (window.gsap) window.gsap.set(t, { opacity: 1 }); }
      });
      var edito = O.$('[data-editorial]', grille);
      if (edito) edito.hidden = !tous;
      compteurs.forEach(function (c) { c.textContent = libelle(n); });
      onglets.forEach(function (o) { o.classList.toggle('is-actif', o === b); });
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }
    onglets.forEach(function (b) {
      b.addEventListener('click', function () { filtrer(b); });
    });
    // Active un onglet puis fait défiler jusqu'à la barre de la grille
    function allerA(cible) {
      filtrer(cible);
      var barre = O.$('.coll__barre', root);
      var y = barre.getBoundingClientRect().top + window.scrollY - (document.querySelector('[data-header]') || { offsetHeight: 0 }).offsetHeight;
      window.scrollTo({ top: y, behavior: O.reduce ? 'auto' : 'smooth' });
    }
    // Entrées du titre (ex. Idées cadeaux) : activent l'onglet du même libellé
    O.$$('[data-onglet-lien]').forEach(function (a) {
      if (a.__coll) return; a.__coll = true;
      a.addEventListener('click', function (e) {
        var lib = a.getAttribute('data-onglet-lien').trim().toLowerCase();
        var cible = onglets.filter(function (b) { return b.textContent.trim().toLowerCase() === lib; })[0];
        if (!cible) return;
        e.preventDefault();
        allerA(cible);
      });
    });
    // Modèles du titre (section voisine) : filtrent la grille si l’onglet existe
    O.$$('[data-modele-lien]').forEach(function (a) {
      if (a.__coll) return; a.__coll = true;
      a.addEventListener('click', function (e) {
        var m = a.getAttribute('data-modele-lien');
        var cible = onglets.filter(function (b) { return b.getAttribute('data-onglet') === m; })[0];
        if (!cible) return;
        e.preventDefault();
        allerA(cible);
      });
    });

    /* Affichage 4 / 2 par rangée --------------------------------------------- */
    var boutonsCol = O.$$('[data-colonnes]', root);
    function colonnes(n) {
      if (!grille) return;
      grille.classList.toggle('is-2', n === '2');
      boutonsCol.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-colonnes') === n ? 'true' : 'false'); });
      try { sessionStorage.setItem('obaia-colonnes', n); } catch (e) {}
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }
    boutonsCol.forEach(function (b) { b.addEventListener('click', function () { colonnes(b.getAttribute('data-colonnes')); }); });
    try { if (sessionStorage.getItem('obaia-colonnes') === '2') colonnes('2'); } catch (e) {}

    /* Tri ---------------------------------------------------------------------- */
    var tri = O.$('[data-tri]', root);
    if (tri) {
      document.addEventListener('click', function (e) { if (tri.open && !tri.contains(e.target)) tri.open = false; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && tri.open) { tri.open = false; O.$('summary', tri).focus(); } });
    }
    var select = O.$('[data-tri-select]', root);
    if (select) select.addEventListener('change', function () { window.location.href = select.value; });

    /* Filtres ------------------------------------------------------------------ */
    var tiroir = O.$('[data-filtres]', root);
    if (!tiroir) return;
    var form = O.$('[data-filtres-form]', tiroir);
    var voir = O.$('[data-filtres-voir]', tiroir);
    var fermerBtn = O.$('.filtres__fermer', tiroir);
    var dernier = null, t = null, req = 0;

    function ouvrir(e) {
      dernier = e && e.currentTarget;
      tiroir.hidden = false;
      document.documentElement.classList.add('filtres-ouverts');
      requestAnimationFrame(function () { requestAnimationFrame(function () { tiroir.classList.add('is-open'); }); });
      setTimeout(function () { fermerBtn.focus(); }, 50);
    }
    function fermer() {
      tiroir.classList.remove('is-open');
      document.documentElement.classList.remove('filtres-ouverts');
      setTimeout(function () { tiroir.hidden = true; }, 600);
      if (dernier) dernier.focus();
    }
    O.$$('[data-filtres-ouvrir]', root).forEach(function (b) { b.addEventListener('click', ouvrir); });
    O.$$('[data-filtres-fermer]', tiroir).forEach(function (b) { b.addEventListener('click', fermer); });
    document.addEventListener('keydown', function (e) {
      if (tiroir.hidden) return;
      if (e.key === 'Escape') fermer();
      if (e.key === 'Tab') {                                   // le focus reste dans le tiroir
        var f = O.$$('a[href], button:not([disabled]), input:not([disabled]), summary', tiroir).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });

    // Nombre de résultats pour les choix en cours : on demande la section à Shopify
    function majCompte() {
      var params = new URLSearchParams(new FormData(form));
      O.$$('input[type="number"]', form).forEach(function (i) { if (!i.value) params.delete(i.name); });
      params.set('section_id', root.getAttribute('data-section-id'));
      var id = ++req;
      voir.classList.add('is-chargement');
      fetch(form.getAttribute('action') + '?' + params.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (id !== req) return;
          var m = html.match(/data-total="(\d+)"/);
          if (m) {
            var n = parseInt(m[1], 10);
            var T = window.OBAIA_T || {};
            voir.textContent = n === 1 ? (T.voir_un || 'Voir le') + ' ' + mot1 : (T.voir_les || 'Voir les') + ' ' + n + ' ' + motN;
            voir.disabled = n === 0;
          }
        })
        .catch(function () {})
        .then(function () { if (id === req) voir.classList.remove('is-chargement'); });
    }
    form.addEventListener('change', function () { clearTimeout(t); t = setTimeout(majCompte, 250); });
    // Champs de prix vides : non envoyés (sinon Shopify filtre sur 0)
    form.addEventListener('submit', function () {
      O.$$('input[type="number"]', form).forEach(function (i) { if (!i.value) i.disabled = true; });
    });
  }

  O.section('collection', { init: init });
})();
